import type { Entity } from '@models/Entity'

import { apiClient } from '../../../gateways/api'
import type { AssignedBijlage } from '../types/AssignedBijlage'

export { createAssignedBijlageForEntity }

const createAssignedBijlageForEntity = async ({
  entity: { type, id },
  subprocesId,
  bijlageInfo,
}: {
  entity: Entity
  subprocesId?: string
  bijlageInfo: Partial<AssignedBijlage>
}): Promise<AssignedBijlage> => {
  // een bijlage onder een subproces heeft een eigen route: het subprocesId gaat
  // via het pad mee, de generieke route koppelt geen subproces
  const url = subprocesId
    ? `/rest/${type}/${id}/subproces/${subprocesId}/bijlageassigned`
    : `/rest/${type}/${id}/bijlageassigned`

  const { data } = await apiClient({
    url,
    method: 'POST',
    data: bijlageInfo,
  })

  return data
}
